// extracted by mini-css-extract-plugin
module.exports = {"container":"_3XCXAuyIIQoZbzVEqIoQEh","portionsList":"_2NFYYGIv3HlhRN9t92xIHb"};